import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export var extendColorScheme = function extendColorScheme(colorScheme, overrides) {
  var result = colorScheme;
  Object.keys(overrides).forEach(function (color) {
    result = Object.assign({}, result, _defineProperty({}, color, Object.assign({}, colorScheme[color], overrides[color])));
  });
  return result;
};
export function pickValuesFromColorScheme(colorScheme, componentAreas) {
  var result = {};
  Object.keys(colorScheme).forEach(function (color) {
    var colorValues = componentAreas.reduce(function (accumulator, area) {
      return Object.assign({}, accumulator, _defineProperty({}, area, colorScheme[color][area]));
    }, {});
    result = Object.assign({}, result, _defineProperty({}, color, colorValues));
  });
  return result;
}